<template>
  <div class="el-section">
    <div class="eu-container">
      <div class="eu-flex eu-justify_center">
        <div class="eu-flex-item eu-basis_7_md">
          <div class="emd-container _footer_end _mobile-shift">
            <div class="emd-container__header eu-justify_center eu-py_4">
              <span class="emd-text _color_warning">
                <i class="uil uil-exclamation-triangle" style="font-size: 3em;"></i>
              </span>
            </div>
            <div class="emd-container__content eu-align_left eu-pt_5_md eu-pb_6_md eu-px_6_md">
              <div class="el-chunk">
                <h2 class="emd-text _size_page">{{ $t('title', { account: account.name }) }}</h2>
              </div>
              <p class="emd-text _size_section _type_hint">{{ $t('text') }}</p>
            </div>
            <div class="emd-container__footer">
              <a class="emd-btn _type_text _color_primary _size_big" :href="dashUrl">{{ $t('dashCTA') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoAccess',
  computed: {
    account () {
      return this.$store.getters.accountData
    },
    merchant () {
      return this.$store.getters.merchantData
    },
    dashUrl () {
      return `${process.env.VUE_APP_DASH_URL}/${this.merchant.id}/${this.account.id}`
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Opa! A conta {account} ainda não tem acesso ao Shop.",
      "text": "Descubra novas formas de vender e conquiste clientes com mais facilidade.",
      "dashCTA": "Ir para o dash"
    },
    "en-US": {
      "title": "Ops! The account {account} doesn't have access to Shop yet.",
      "text": "Learn new ways to sell and attract clients more easily.",
      "dashCTA": "Go to dash"
    }
  }
</i18n>
